export const getGradeEmoji = (accuracy: number) => {
    if (accuracy >= 90) return "🏆";
    if (accuracy >= 80) return "🥇";
    if (accuracy >= 70) return "🥈";
    if (accuracy >= 60) return "🥉";
    return "📈";
  };